export const answerEvaluConstants = {
    STORE_ANSWERS: 'STORE_ANSWERS_EVALU',
    INIT_ANSWERS: 'INIT_ANSWERS_EVALU'
};